// extracted by css-extract-rspack-plugin
module.exports =  {"root":"Profile__root___mq8qw"};